import { Reveal } from "./Reveal";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1771270759486-1f7703945072?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHw0fHxzb3BoaXN0aWNhdGVkJTIwZGFyayUyMG1vZGVybiUyMG9mZmljZXxlbnwwfHx8fDE3ODYwOTE0Mzh8MA&ixlib=rb-4.1.0&q=85";

const STATS = [
  { k: "12+", v: "Years combined expertise" },
  { k: "40+", v: "Brands scaled globally" },
  { k: "3.4x", v: "Average ROAS uplift" },
];

export default function About() {
  return (
    <section id="about" className="py-24 md:py-32 border-b border-white/10">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <Reveal>
              <p className="text-xs tracking-[0.35em] uppercase text-accent mb-6">About Us</p>
              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
                A consultancy for brands that refuse to blend in.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 text-muted-foreground leading-relaxed text-base md:text-lg max-w-md">
                Based in Bromley, London, Leylak Marketing Ltd partners with founders and
                marketing teams across the United Kingdom and internationally. We combine
                sharp strategy, data-driven advertising and elegant creative to turn
                attention into measurable growth.
              </p>
            </Reveal>

            <div className="mt-12 grid grid-cols-3 gap-4">
              {STATS.map((s, i) => (
                <Reveal key={s.k} delay={0.15 + i * 0.08}>
                  <div className="border-l border-white/15 pl-4">
                    <div className="font-display text-3xl md:text-4xl text-accent">{s.k}</div>
                    <div className="text-xs text-muted-foreground mt-2 leading-snug">{s.v}</div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.15}>
              <div className="hover-media relative overflow-hidden rounded-sm border border-white/10 inner-glow">
                <img
                  src={ABOUT_IMG}
                  alt="Leylak Marketing studio"
                  className="w-full h-[420px] md:h-[560px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background/60 to-transparent pointer-events-none" />
                <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
                  <span className="font-display italic text-2xl md:text-3xl">Est. London</span>
                  <span className="text-xs tracking-[0.3em] uppercase text-muted-foreground">
                    UK · Worldwide
                  </span>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
